/// <amd-module name="Notifications/Tools/Components/SystemInputs" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";

export interface ISystemInputsProps {
    onChange: (systemInputs: { [key: string]: string }) => void;
}

export interface ISystemInputsState {
    sytemInputsText: string;
    errorMessage: string | undefined;
}

export class SystemInputs extends VssComponent<ISystemInputsProps, ISystemInputsState> {
    private systemInputsDict: { [key: string]: string | null };

    public constructor(props: ISystemInputsProps) {
        super(props);

        this.systemInputsDict = {
            subscriptionId: "1",
            subscriptionReason: null,
            subscriptionUrl: null,
            subscriptionUnsubscribeAction: null,
            subscriptionUnsubscribeUrl: null,
            productName: null
        };

        this.state = {
            sytemInputsText: JSON.stringify(this.systemInputsDict, null, 2),
            errorMessage: undefined
        };
    }

    public onChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
        let err: string | undefined;

        try {
            const dict = JSON.parse(value);
            this.props.onChange && this.props.onChange(dict);
        } catch (e) {
            err = e.message;
        }

        this.setState({
            sytemInputsText: value,
            errorMessage: err
        });
    };

    public render(): JSX.Element | null {
        const { sytemInputsText, errorMessage } = this.state;
        return (
            <div>
                <h4>Specify the system inputs</h4>
                <FormItem
                    message={errorMessage}
                >
                    <TextField 
                        autoAdjustHeight={true}
                        multiline={true}
                        onChange={this.onChange}
                        required={true}
                        spellCheck={false}
                        value={sytemInputsText}
                    />
                </FormItem>
            </div>
        );
    }
}
